module.exports = require('./helpers/bundle-url').getBundleURL('4afSR') + "call.a1974ac8.png";